import { Commit } from 'vuex';
import { ReglementFournisseurState } from '.';

export interface ReglementFournisseurActionType {
    commit: Commit;
    state: ReglementFournisseurState;
    getters: any;
}

export enum ReglementFournisseurActions {
    GET_REGLEMENTS = 'GET_REGLEMENTS',
    GET_XLS = 'GET_XLS'
}
